import React, { Component }  from 'react'
import { compose, graphql } from 'react-apollo'
import queryEvent from '~/graphql/queries/queryEvent.gql'
// import RunnereSlip from '../components/RunnereSlip';
import RunnerGetEcer from './RunnerGetEcer';

const apiUri = process.env.REACT_APP_ECER_API_URI

class RunnerEcer extends Component {
  render() {
    if(!this.props.data.event){
      return <div className="ecer" >Loading...RunnerEcereSlip</div>
    } 
    const date = this.props.data.event
    const event = date.event
    const slug = this.props.slug
    const bib = parseFloat(this.props.bib)
    return(
        <div>
            {event && <RunnerGetEcer event={event} slug={slug} bib={bib}/>}
        </div>
    )
  }
}

export default compose(
  graphql(queryEvent, {
    options: ({ slug }) => ({
      variables: {
        slug,
      },
      context: {
        uri: apiUri
      }
    })
  })
)(RunnerEcer)